import api from "../utils/api";
import { trimMobile } from "../utils/siteUtils";

export const getEmailCode = async (email, type) => {
  const { obj } = await api.verification.email.get(null, {
    email,
    type
  });
  return obj;
};
export const checkEmailCode = async (email, verificationCode, type) => {
  const { obj } = await api.verification.email.check(null, {
    email,
    type,
    verificationCode
  });
  return obj;
};
export const getSMSCode = async (mobileCountryCode, mobile, type) => {
  return await api.verification.mobile.get(null, {
    mobileCountryCode,
    mobile: trimMobile(mobile),
    type
  });
};
export const checkSMSCode = async (mobileCountryCode, mobile, verificationCode, type) => {
  return await api.verification.mobile.check(null, {
    mobileCountryCode,
    mobile: trimMobile(mobile),
    verificationCode,
    type
  });
};
export const updateMobile = async (mobileNoCountryCode, mobileNo, code, userAccount) => {
  return await api.user.mobile.update(null, {
    mobileNoCountryCode,
    mobileNo: trimMobile(mobileNo),
    code,
    userAccount
  });
};
export const getVerificationMethods = user => {
  let methods = [];
  if (user.mobileNoCountryCode && user.mobileNo) {
    methods.push({ id: methods.length + 1, type: "phone", fields: { phoneArea: user.mobileNoCountryCode, phoneNumber: user.mobileNo } });
  }

  methods.push({ id: methods.length + 1, type: "email", fields: { email: user.email } });
  return methods;
};
